import AuthStore from './AuthStore';
import CouponFilterStore from './CouponFilterStore';
import LanguageStore from './LanguageStore';
import LocationStore from './LocationStore';
import ReservationFilterStore from './ReservationFilterStore';
import UserFilterStore from './UserFilterStore';
import VoucherFilterStore from './VoucherFilterStore';
import MessageFilterStore from './MessageFilterStore';
interface ILocalStore {
  locationStore: LocationStore;
  authStore: AuthStore;
  languageStore: LanguageStore;
  reservationFilterStore: ReservationFilterStore;
  userFilterStore: UserFilterStore;
  voucherFilterStore: VoucherFilterStore;
  couponFilterStore: CouponFilterStore;
  messageFilterStore: MessageFilterStore;
}

const LocalStore: ILocalStore = {
  locationStore: new LocationStore(),
  authStore: new AuthStore(),
  languageStore: new LanguageStore(),
  reservationFilterStore: new ReservationFilterStore(),
  userFilterStore: new UserFilterStore(),
  voucherFilterStore: new VoucherFilterStore(),
  couponFilterStore: new CouponFilterStore(),
  messageFilterStore: new MessageFilterStore(),
};

export { ILocalStore, LocalStore };
